import React, { useEffect, useState } from "react";
import { useLang } from "../../i18n/LanguageContext";

const Header = () => {
  const { lang, toggle, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "servicios", key: "nav.services" },
    { id: "proyectos", key: "nav.projects" },
    { id: "diferenciadores", key: "nav.about" },
    { id: "testimonios", key: "nav.testimonials" },
    { id: "contacto", key: "nav.contact" },
  ];

  const goTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAFAFA]/85 backdrop-blur-xl border-b border-[#E5E5E5]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <button
          data-testid="logo-home-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
          aria-label="AARK home"
        >
          <img
            src="/aark-logo-dark.png"
            alt="AARK"
            className="h-8 md:h-10 w-auto"
            draggable="false"
          />
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => goTo(l.id)}
              className="font-mono-label text-[#111] hover:text-[#666] transition-colors"
            >
              {t(l.key)}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3 md:gap-5">
          <div className="flex items-center font-mono-label">
            <button
              data-testid="lang-es-btn"
              onClick={() => lang !== "es" && toggle()}
              className={`px-1 transition-colors ${lang === "es" ? "text-[#111]" : "text-[#999] hover:text-[#111]"}`}
            >
              ES
            </button>
            <span className="text-[#ccc]">/</span>
            <button
              data-testid="lang-en-btn"
              onClick={() => lang !== "en" && toggle()}
              className={`px-1 transition-colors ${lang === "en" ? "text-[#111]" : "text-[#999] hover:text-[#111]"}`}
            >
              EN
            </button>
          </div>
          <button
            data-testid="header-cta-btn"
            onClick={() => goTo("contacto")}
            className="hidden md:inline-flex btn-primary"
            style={{ padding: "0.7rem 1.4rem", fontSize: "0.75rem" }}
          >
            {t("nav.cta")}
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5"
            aria-label="Menu"
          >
            <span className={`block w-5 h-px bg-[#111] transition-transform ${open ? "translate-y-[3px] rotate-45" : ""}`} />
            <span className={`block w-5 h-px bg-[#111] transition-transform ${open ? "-translate-y-[3px] -rotate-45" : ""}`} />
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[#E5E5E5] bg-[#FAFAFA]">
          <div className="container-x py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-${l.id}-link`}
                onClick={() => goTo(l.id)}
                className="text-left font-display text-2xl text-[#111]"
              >
                {t(l.key)}
              </button>
            ))}
            <button
              data-testid="mobile-header-cta-btn"
              onClick={() => goTo("contacto")}
              className="btn-primary mt-2 self-start"
            >
              {t("nav.cta")}
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
